module.exports = __webpack_public_path__ + "images/08522c2539e312922c2fe8395fd3b524.svg";